<template>
  <v-container fluid class="ma-0 pa-0">
    <v-row align-content="center" align="center" justify="center">
      <v-col cols="12" class="py-12">
        <v-container>
          <v-row style="width: -webkit-fill-available">
              <div class="px-2">
                <div class="home-header-2 mt-6 mb-8">
                  Useful links
                </div>
                <div class="mb-12 home-text-2">
                  <v-container>
                    <v-row>
                      <v-col
                          v-for="(item, i) in links"
                          :key="i"
                          cols="12"
                          sm="6"
                          md="3"
                      >
                        <a
                            :href="item.href"
                            class="pill-link"
                        >
                          {{ item.label }}
                        </a>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
              </div>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'UsefulLinks',
  data() {
    return {
      links: [
        { label: 'NIDirect - Immunisations and vaccinations', href: 'https://www.nidirect.gov.uk/information-and-services/living-well/immunisation-and-vaccinations' },
        { label: 'NIDirect Coronavirus Advice', href: 'https://www.nidirect.gov.uk/information-and-services/health-and-wellbeing/coronavirus-covid-19' },
        { label: 'Public Health Agency', href: 'https://www.publichealth.hscni.net/' },
        { label: 'NIDirect', href: 'https://www.nidirect.gov.uk/' },
        { label: 'GP out of hours service', href: 'https://www.nidirect.gov.uk/articles/gp-out-hours-service' },
        { label: 'Mental Health Foundation', href: 'https://www.mentalhealth.org.uk/' },
        { label: 'Minding your head', href: 'https://www.mindingyourhead.info/' },
        { label: 'NI Social Care Council', href: 'https://niscc.info/' },
      ]
    }
  }
};
</script>

<style>
.pill-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 4em;
  padding: 12px 16px;
  border-radius: 10px;
  outline: 2px solid #004651;
  outline-offset: 2px;
  background-color: transparent;
  text-align: center;
  white-space: normal;
  word-break: break-word;
  line-height: 1.3;
  transition: background-color 0.2s ease;
}

.pill-link:hover {
  outline: 2px solid #004651;
  outline-offset: 2px;
}
</style>